const version = {
   vendorVersion: 1.2,
   appVersion: "3.36802",
};

module.exports = version;
